import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { LocalPhone } from "@mui/icons-material";
import { Button } from "@mui/material";
import { openCustomerDialog } from "../../Store/Slices/customerSlice";
import { createPhoneOrder } from "../../Store/Slices/restaurantSlice";

const PhoneOrderButton = ({ sx }) => {
  const dispatch = useDispatch();
  const awaitingRef = useRef(false);

  useEffect(() => {
    const handleCustomerChange = (event) => {
      if (!awaitingRef.current) return;

      const customer = event?.detail?.customer;
      if (!customer) return;

      awaitingRef.current = false;

      const phone =
        customer.custMobile ||
        customer.custEmail ||
        (customer.custId != null ? String(customer.custId) : "");

      dispatch(
        createPhoneOrder({
          customerName: customer.custName || "",
          phone,
          custId: customer.custId ?? null,
        })
      );
    };

    window.addEventListener("pos:customer-changed", handleCustomerChange);
    return () =>
      window.removeEventListener("pos:customer-changed", handleCustomerChange);
  }, [dispatch]);

  const handleClick = () => {
    awaitingRef.current = true;
    dispatch(openCustomerDialog());
  };

  return (
    <Button
      variant="contained"
      size="large"
      startIcon={<LocalPhone sx={{ fontSize: "1.6rem !important" }} />}
      onClick={handleClick}
      sx={{
        textTransform: "none",
        fontWeight: 700,
        fontSize: "1.05rem",
        px: 2.5,
        py: 1.2,
        borderRadius: 2,
        backgroundColor: "#7c3aed",
        "&:hover": { backgroundColor: "#6d28d9" },
        ...sx,
      }}
    >
      Phone Order
    </Button>
  );
};

export default PhoneOrderButton;
